import React from 'react'
import Modal from './Modal'

export default function ModalAlert({ alert, mode, cancelText, acceptText, onSelect, onClose }) {
  return (
    <Modal
      visible={ true }
      closeModal={ onClose }
      mode={`${mode || 'small'} centered alert-modal`}
      action={ onSelect }
      actionText={ acceptText || Cas.translations.confirm }
      cancelAction={ onClose }
      cancelActionText={ cancelText || Cas.translations.cancel }
    >
      <div className='modal-alert'>
        <div className='modal-alert-icon'>
          <i className='fa-light fa-triangle-exclamation'></i>
        </div>
        <div className='modal-alert-copy'>
          { alert }
        </div>
      </div>
    </Modal>
  )
}
